import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Popup from '../../../common/Popup';
import * as irActions from '../../../../redux/actions/irSearch';
import EmailFormPopup from './EmailFormPopup';
import DocketDetailsPurchaseForm from '../DocketDetailsPurchaseForm';


class EmailAllPartsZipPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showPurchaseForm: false,
      email_address: '',
      email_message: '',
    };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.docketParts.alreadyPurchased && this.props.docketParts.alreadyPurchased) {
      this.emailPdfsZip();
    }
  }

  getParams = () => {
    const { email_address, email_message } = this.state;
    return {
      ...this.props.popup.data,
      email_address,
      email_message,
    };
  }

  onSubmit = (params) => {
    const { email_address, email_message } = params;
    this.setState({ showPurchaseForm: true, email_address, email_message }, () => {
      this.props.dispatch(irActions.getDocketParts(params));
    });
  }

  buy = () => {
    if (this.props.dispatch(irActions.checkClientCodeValid())) {
      this.props.dispatch(irActions.buyAllParts(this.getParams())).then(() => this.emailPdfsZip());
    } else {
      this.props.onClose();
    }
  }

  emailPdfsZip = () => {
    this.props.dispatch(irActions.emailPdfsZip(this.getParams()))
      .then(this.props.reloadDetails)
      .then(() => {
        this.setState({ showPurchaseForm: false });
      });
  }

  onClose = () => {
    this.setState({ showPurchaseForm: false });
    this.props.onClose();
  }

  render() {
    const { docketParts, popup } = this.props;

    return (this.state.showPurchaseForm)
      ? (
        <Popup show={popup.show}
               clsName="docket-pdf-zip-popup"
               topBarTitle="Email Zip File"
               onClose={this.onClose}>
          <DocketDetailsPurchaseForm
            docketParts={docketParts}
            buy={this.buy} />
        </Popup>
      )
      : (
        <EmailFormPopup {...this.props} onSubmit={this.onSubmit} />
      );
  }
}

EmailAllPartsZipPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  docketParts: PropTypes.object.isRequired,
  popup: PropTypes.object.isRequired,
  reloadDetails: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { popup, docketParts, favoriteEmail } = state.get('dockets').toJS();

  return {
    popup,
    docketParts,
    favoriteEmail,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailAllPartsZipPopup);



/** WEBPACK FOOTER **
 ** ./src/components/case/docket/popups/EmailAllPartsZipPopup.jsx
 **/